import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import { SnackbarProvider } from "./Components/Snackbar/SnackBarContext";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import store from "./StateManagement/store";
import { Toaster } from "react-hot-toast";
import OfflineNotifier from "./FrontEnd/components/offlineNotfier";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./StateManagement/authContext";
import { ThemeContextProvider } from "./StateManagement/themeContext";

const initialOptions = {
  clientId: "sb-8z5bb3685001@personal.example.com", // Replace with your PayPal Client ID
  currency: "INR" // Set your desired currency
};

// const root = ReactDOM.createRoot(
//   document.getElementById('root') as HTMLElement
// );

ReactDOM.render(
  <Provider store={store}>
    <ThemeContextProvider>
      <Toaster position="top-center" />
    <OfflineNotifier />
    <SnackbarProvider>
     <AuthProvider>
       <BrowserRouter >
          <App />
      </BrowserRouter>
     </AuthProvider>
    </SnackbarProvider>
    </ThemeContextProvider>
  </Provider>,
  document.getElementById("root")
);


reportWebVitals();
